import {Input} from 'antd';
import {FormInstance} from 'antd/es/form';
import cn from 'classnames';
import React, {FC} from 'react';

import {IFieldMeta} from 'entities/metadata';
import {IFormEntityData} from 'modules/data/data-types';

import {Field} from '../../field/field';

import './inline-fields.less';

interface IInlineFieldsProps {
    fields?: IFieldMeta[];
    formData?: IFormEntityData;
    form?: FormInstance;
    disabled?: boolean;
}

export const InlineFields: FC<IInlineFieldsProps> = ({
    fields,
    form,
    formData,
    disabled,
}: IInlineFieldsProps) => (
    <Input.Group className="inline-fields">
        {
            fields?.map(fieldMeta => (
                <Field
                    formData={formData}
                    key={fieldMeta.key}
                    fieldMeta={{...fieldMeta, isDisabled: disabled || fieldMeta.isDisabled}}
                    form={form}
                    innerClassNames={cn('inline-field')}
                />
            ))
        }
    </Input.Group>
);
